export enum TimelineStatus {
    OPEN = 'open',
    COMPLETE = 'complete',
    OVERDUE = 'overdue'
}

export const TimelineStatusBootstrapColorMap: Record<TimelineStatus, string> = {
    [TimelineStatus.OPEN]: 'primary-lighten',
    [TimelineStatus.COMPLETE]: 'success-lighten',
    [TimelineStatus.OVERDUE]: 'danger-lighten',
};

export enum DateField {
    TARGET = 'target',
    COMPLETED = 'completed'
}

export const NO_SECTION_LABEL = 'No section';

// UI-only sentinel: NSDropdown option values must be React keys, so null can't be one.
// Section ids are always positive, which makes 0 safe to reserve for "No section".
export const NO_SECTION_VALUE = 0;

export const NO_SECTIONS_YET_LABEL = 'No sections yet';

export const MOVE_TO_SECTION_LABEL = 'Move to section';